import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";

export default class IsAllowedRandomSelectionInteractor {
  private reportingPeriodService: IReportingPeriodService;

  constructor(reportingPeriodService) {
    this.reportingPeriodService = reportingPeriodService;
  }

  async execute(reportingPeriodId: number) {
    return this.reportingPeriodService.isAllowedRandomSelection(
      reportingPeriodId
    );
  }
}
